import { useI18n } from 'vue-i18n';

export function getStoreyOptions() {
  const i18n = useI18n();
  const { t } = i18n;

  return [
    { label: t('filter.storey.cellar'), value: -1 },
    { label: t('filter.storey.ground_floor'), value: 0 },
    ...Array.from({ length: 10 }, (_, i) => ({
      label: t('filter.storey.floor', { value: i + 1 }),
      value: i + 1,
    })),
  ];
}
